module.exports = __webpack_public_path__ + "static/media/4、宝鸡市自来水有限责任公司股权回购项目咨询-min.9c32949e.jpg";